import { apiRequest } from "./apiClient";

const DEFAULT_PREMIUM_CONFIG = {
  premiumEnabled: false,
  limits: {
    alisverisOge: 10, aktifGorev: 10, aylikTakvim: 10, aylikFinans: 15,
    saglikKayitKisi: 10, cocukProfil: 1, belgeSayisi: 5, belgeDepoMB: 30,
    mesajGecmis: 30, kayitliYer: 3, aileUye: 3, kullaniciAile: 1,
    premiumPlusToplamUye: 5, gunlukNePisirsam: 2,
  },
  lockedFeatures: {
    finansRapor: true, finansBirikim: true, finansTaksit: true, finansAbonelik: true,
    finansFatura: true, canliKonum: true, geofence: true, konumGecmisi: true,
    evcilHayvanProfil: true, haftalikMenu: true, cokluSohbetOdasi: true,
    zamanlanmisBildirim: true, otomatikBildirim: true, cokluAile: true,
  },
};

function normalizeConfig(config = {}) {
  return {
    premiumEnabled: typeof config.premiumEnabled === "boolean" ? config.premiumEnabled : DEFAULT_PREMIUM_CONFIG.premiumEnabled,
    limits: {
      ...DEFAULT_PREMIUM_CONFIG.limits,
      ...(config.limits || {}),
    },
    lockedFeatures: {
      ...DEFAULT_PREMIUM_CONFIG.lockedFeatures,
      ...(config.lockedFeatures || {}),
    },
  };
}

export async function getPremiumConfig() {
  const data = await apiRequest("/premium/config");
  return normalizeConfig(data.config || data.premiumConfig || data);
}

export async function getPremiumStatus(familyId) {
  const q = familyId ? `?familyId=${encodeURIComponent(familyId)}` : "";
  const data = await apiRequest(`/premium/status${q}`);
  return {
    userIsPremium: !!data.userIsPremium,
    familyIsPremium: !!data.familyIsPremium,
    familyIsPremiumPlus: !!data.familyIsPremiumPlus,
    premiumConfig: normalizeConfig(data.premiumConfig || data.config || {}),
  };
}

/**
 * Premium ayarlarını backend/PostgreSQL tarafına yazar.
 * Eski Firestore systemSettings/premiumConfig dokümanını artık kullanmaz.
 */
export async function savePremiumConfig(config) {
  const normalized = normalizeConfig(config || {});
  const data = await apiRequest("/premium/config", {
    method: "PUT",
    body: JSON.stringify(normalized),
  });
  return normalizeConfig(data.config || data.premiumConfig || normalized);
}

export async function setUserPremium(uid, isPremium) {
  const data = await apiRequest(`/premium/users/${encodeURIComponent(uid)}`, {
    method: "PATCH",
    body: JSON.stringify({ isPremium: !!isPremium }),
  });
  return data.user || data;
}
